import { createStore, getActionIds } from '../helpers/redux';
import Immutable, { List, Map } from 'immutable';

import { ElementActions } from '../actions/element';
import { ProjectActions } from '../actions/project';
import { RelationshipActions } from '../actions/relationship';

const projectActions = getActionIds(ProjectActions);
const elementActions = getActionIds(ElementActions);
const relationshipActions = getActionIds(RelationshipActions);

const initialState = Immutable.fromJS({
  children: {},
  parents: {},
  providesTo: {},
  consumesFrom: {},
});

export const elementRelationships = createStore(initialState, {
  [projectActions.resetReducers]: (state, action) => {
    return initialState;
  },

  '*': (state, action) => {
    if (
      action.result &&
      action.result.entities &&
      action.result.entities.relationships
    ) {
      let providesTo = state.get('providesTo');
      let consumesFrom = state.get('consumesFrom');
      for (let relationshipId in action.result.entities.relationships) {
        const relationship =
          action.result.entities.relationships[relationshipId];

        if (!List.isList(providesTo.get(relationship.producer))) {
          providesTo = providesTo.set(relationship.producer, List());
        }

        if (
          providesTo
            .get(relationship.producer)
            .indexOf(relationship.consumer) === -1
        ) {
          providesTo = providesTo.set(
            relationship.producer,
            providesTo.get(relationship.producer).push(relationship.consumer),
          );
        }

        if (!List.isList(consumesFrom.get(relationship.consumer))) {
          consumesFrom = consumesFrom.set(relationship.consumer, List());
        }

        if (
          consumesFrom
            .get(relationship.consumer)
            .indexOf(relationship.producer) === -1
        ) {
          consumesFrom = consumesFrom.set(
            relationship.consumer,
            consumesFrom.get(relationship.consumer).push(relationship.producer),
          );
        }
      }

      return state
        .set('consumesFrom', consumesFrom)
        .set('providesTo', providesTo);
    }

    if (
      action.result &&
      action.result.entities &&
      action.result.entities.elements
    ) {
      // if (action.result.entities.elements.consumers)
      // const elementId = action.result.result;
      const elements = action.result.entities.elements;

      const elementConsumers = {};
      const elementProducers = {};

      for (let elementId in elements) {
        const element = elements[elementId];

        elementConsumers[elementId] = element.consumers || [];
        elementProducers[elementId] = element.producers || [];
      }

      return state.mergeDeep({
        providesTo: elementConsumers,
        consumesFrom: elementProducers,
      });
    }

    return state;
  },

  [relationshipActions.deleteRelationships.success]: (state, action) => {
    action.result.relationships.forEach(rel => {
      let consumesFrom = state.getIn(['consumesFrom', rel.consumer]);
      let providesTo = state.getIn(['providesTo', rel.producer]);

      if (!consumesFrom) {
        consumesFrom = List();
      }
      if (!providesTo) {
        providesTo = List();
      }
      const consumerConsumesFrom = consumesFrom.findIndex(
        v => v === rel.producer,
      );
      if (consumerConsumesFrom > -1)
        consumesFrom = consumesFrom.delete(consumerConsumesFrom);

      const producerProvidesTo = providesTo.findIndex(v => v === rel.consumer);
      if (producerProvidesTo > -1)
        providesTo = providesTo.delete(producerProvidesTo);

      state = state
        .setIn(['providesTo', rel.producer], providesTo)
        .setIn(['consumesFrom', rel.consumer], consumesFrom);
    });

    return state;
  },

  // [relationshipActions.deleteRelationships.success]: (state, action) => {
  //   debugger;
  // },

  // [relationshipActions.deleteRelationship]: (state, action) => {
  //   const relationshipId = action.result.id;
  //   const producer = action.result.producer;
  //   const consumer = action.result.consumer;

  //   let providesTo = state.get('providesTo');
  //   let consumesFrom = state.get('consumesFrom');

  //   action.elementIds.forEach((elementId) => {
  //     providesTo = providesTo.delete(elementId);
  //     consumesFrom = consumesFrom.delete(elementId);
  //   })

  //   providesTo = providesTo.map((child) => {
  //     return child.filter((childId) => {
  //       return action.elementIds.indexOf(childId) == -1
  //     })
  //   })

  //   consumesFrom = consumesFrom.map((child) => {
  //     return child.filter((childId) => {
  //       return action.elementIds.indexOf(childId) == -1
  //     })
  //   })

  //   return state.setIn(['providesTo'], providesTo)
  //     .setIn(['consumesFrom'], consumesFrom);
  // },

  [elementActions.clientDeleteElements]: (state, action) => {
    let children = state.get('children');
    let parents = state.get('parents');
    let providesTo = state.get('providesTo');
    let consumesFrom = state.get('consumesFrom');

    action.elementIds.forEach(elementId => {
      children = children.delete(elementId);
      parents = parents.delete(elementId);
      providesTo = providesTo.delete(elementId);
      consumesFrom = consumesFrom.delete(elementId);
    });

    children = children.map(child => {
      return child.filter(childId => {
        return action.elementIds.indexOf(childId) === -1;
      });
    });

    providesTo = providesTo.map(child => {
      return child.filter(childId => {
        return action.elementIds.indexOf(childId) === -1;
      });
    });

    consumesFrom = consumesFrom.map(child => {
      return child.filter(childId => {
        return action.elementIds.indexOf(childId) === -1;
      });
    });

    return state
      .setIn(['children'], children)
      .setIn(['parents'], parents)
      .setIn(['providesTo'], providesTo)
      .setIn(['consumesFrom'], consumesFrom);
  },

  [projectActions.getRootElement.success]: (state, action) => {
    let parentObject = {};
    let childrenObject = {};

    Object.keys(action.result.entities.elements).forEach(elementId => {
      // console.log('+', elementId, action.result.entities.elements[elementId].parent_id);
      // This commented out code is backwards. redid it but not sure if anything else breaks.

      // if(parentObject[action.result.entities.elements[elementId].parent_id]){
      //   parentObject[action.result.entities.elements[elementId].parent_id].push(elementId)
      // } else {
      //   parentObject[action.result.entities.elements[elementId].parent_id] = [elementId]
      // }
      parentObject[elementId] = action.result.entities.elements[elementId]
        .parent_id
        ? action.result.entities.elements[elementId].parent_id
        : [];
      childrenObject[elementId] = action.result.entities.elements[elementId]
        .children
        ? action.result.entities.elements[elementId].children
        : [];
    });

    // debugger;
    return state.mergeDeep({
      children: childrenObject,
      parents: parentObject,
    });
  },

  [elementActions.getElement.success]: (state, action) => {
    if (!action.result.entities.elements) return state;

    return state.mergeDeep({
      children: {
        [action.result.result]:
          action.result.entities.elements[action.result.result].children,
      },
      parents: {
        [action.result.result]:
          action.result.entities.elements[action.result.result].parent_id,
      },
    });
  },

  [elementActions.createElement.success]: (state, action) => {
    if (!action.result.entities.elements) return state;

    const children = {};
    action.result.result.forEach(x => {
      children[x] = List();
    });

    children[action.args[1].parent_id] = state
      .get('children')
      .get(action.args[1].parent_id, List())
      .concat(action.result.result);

    const parents = {};
    action.result.result.forEach(x => {
      parents[x] = action.args[1].parent_id;
    });

    return state.mergeDeep({
      children,
      parents,
    });
  },

});

export const elementRelationshipsSelector = state => {
  return state.elementRelationships || Map();
}



// WEBPACK FOOTER //
// ./src/reducers/elementRelationships.js